<template>
  <div id="app">
    <HeaderNav :class="{'slide' : isOver}" class="header-nav" ref="scrollOne" />
    <router-view/>
  </div>
</template>
<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import Footer from '@/components/footer.vue'
export default {
  name: 'App',
  components:{
    HeaderNav,
    Footer
  },
  data(){
    return {
      isOver:false,
    }
  },
  mounted() {
    window.addEventListener("scroll",this.handleScroll)
  },
  methods:{
    handleScroll(){
      //获取滚动时的高度
              let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
              if (scrollTop > 200) {
                //大于200的时候要做的操作
                this.isOver = true
              }else{
                this.isOver = false
              }
    },
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html,body{
    background-color: #F5F7FA;
    margin: 0;
    padding: 0;
    height: 100vh;
  }
  .header-nav{
    position: sticky;
    z-index: 9;
    top: 0;

  }
.slide{
  transform: translateY(-200px);
  transition: transform .5s ease-out;
}

</style>



// WEBPACK FOOTER //
// src/App.vue